import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";
import FreePage from "@/pages/FreePage";
import SuccessPage from "@/pages/SuccessPage";
import AdminPage from "@/pages/AdminPage";
import { setLenis } from "@/lib/lenis";

const ScrollReset = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!pathname.includes("#")) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, duration: 1.15 });
    setLenis(lenis);
    return () => lenis.destroy();
  }, []);

  return (
    <BrowserRouter>
      <ScrollReset />
      <div className="min-h-screen bg-obsidian text-slate-200 font-sans">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/free" element={<FreePage />} />
          <Route path="/terms" element={<LegalPage kind="terms" />} />
          <Route path="/privacy" element={<LegalPage kind="privacy" />} />
          <Route path="/refund-policy" element={<LegalPage kind="refund" />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" theme="dark" />
      </div>
    </BrowserRouter>
  );
}
